export const PERISCOPE_VALIDATION_RULE_COPY = {
	CODE_SNIPPET: 'Code Snippet',
	PARENT_OBJECT: 'Parent Object'
};
